import { createSelector } from "../../deps.js";
const excludesFalse = (n) => Boolean(n);
export function defaultLoaderItem(li = {}) {
    return {
        id: "",
        status: "idle",
        message: "",
        lastRun: 0,
        lastSuccess: 0,
        meta: {},
        ...li,
    };
}
export function defaultLoader(l = {}) {
    const loading = defaultLoaderItem(l);
    return {
        ...loading,
        isIdle: loading.status === "idle",
        isError: loading.status === "error",
        isSuccess: loading.status === "success",
        isLoading: loading.status === "loading",
        isInitialLoading: (loading.status === "idle" || loading.status === "loading") &&
            loading.lastSuccess === 0,
    };
}
function loaderSelectors(selectTable) {
    const empty = defaultLoader();
    const tableAsList = (data) => Object.values(data).filter(excludesFalse);
    const findById = (data, { id }) => (defaultLoader(data[id]) || empty);
    const findByIds = (data, { ids }) => ids.map((id) => defaultLoader(data[id])).filter(excludesFalse);
    const selectById = createSelector(selectTable, (_, p) => p.id, (loaders, id) => findById(loaders, { id }));
    return {
        findById,
        findByIds,
        selectTable,
        selectTableAsList: createSelector(selectTable, (data) => tableAsList(data)),
        selectById,
        selectByIds: createSelector(selectTable, (_, p) => p.ids, (loaders, ids) => findByIds(loaders, { ids })),
    };
}
const ts = () => new Date().getTime();
export const createLoaders = ({ name, initialState = {}, }) => {
    const selectors = loaderSelectors((s) => s[name]);
    return {
        schema: "loader",
        name: name,
        initialState,
        start: (e) => (s) => {
            const table = selectors.selectTable(s);
            const loader = table[e.id];
            table[e.id] = defaultLoaderItem({
                ...loader,
                ...e,
                status: "loading",
                lastRun: ts(),
            });
        },
        success: (e) => (s) => {
            const table = selectors.selectTable(s);
            const loader = table[e.id];
            table[e.id] = defaultLoaderItem({
                ...loader,
                ...e,
                status: "success",
                lastSuccess: ts(),
            });
        },
        error: (e) => (s) => {
            const table = selectors.selectTable(s);
            const loader = table[e.id];
            table[e.id] = defaultLoaderItem({
                ...loader,
                ...e,
                status: "error",
            });
        },
        reset: () => (s) => {
            // deno-lint-ignore no-explicit-any
            s[name] = initialState;
        },
        resetByIds: (ids) => (s) => {
            const table = selectors.selectTable(s);
            ids.forEach((id) => {
                delete table[id];
            });
        },
        ...selectors,
    };
};
export function loaders(initialState) {
    return (name) => createLoaders({ name, initialState });
}
//# sourceMappingURL=loaders.js.map